import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { LoadingSpinner } from '@repo/atomic-components';
import { Sidebar } from '../components/Sidebar';
import { AppShell } from './AppShell';

const PageFallback = () => (
  <div className="flex h-full w-full items-center justify-center">
    <LoadingSpinner />
  </div>
);

/** Layout route for the pages with the sidebar, so it stays mounted (and keeps its state) across page changes. */
export const SidebarLayout = () => (
  <AppShell sidebar={<Sidebar />}>
    {/* Here, not only around `Routes`, so a lazy page loading doesn't unmount the sidebar. */}
    <Suspense fallback={<PageFallback />}>
      <Outlet />
    </Suspense>
  </AppShell>
);
